import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BOTranspRelativeDisease } from "../models/auxiliars/BOTranspRelativeDisease.model";
import { BORelativeDisease } from "../models/BORelativeDisease.model";
import { GlobalConstants } from "../common/global-constants";

@Injectable({
  providedIn: 'root'
}

)
export class RelativeDiseaseService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/RelativeDisease/';

    constructor(private http:HttpClient){}

    getAllByPatientiD(patientId:number):Observable<BORelativeDisease[]>{
        return this.http.get<BORelativeDisease[]>(this.myAppUrl + this.myApiUrl+'getAllByPatientId/'+patientId);
    }

    createOrUpdateRelativeDiseases(transp:BOTranspRelativeDisease):Observable<BORelativeDisease[]>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          const body=JSON.stringify(transp);
          return this.http.post<BORelativeDisease[]>(this.myAppUrl + this.myApiUrl + 'createOrUpdateRelativeDiseases',body,httpOptions);
    }

//#region Single
  createOrUpdateRelativeDiseaseSingle(patientId:number, disease:BORelativeDisease):Observable<BORelativeDisease>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BORelativeDisease>(this.myAppUrl + this.myApiUrl + 'createOrUpdateRelativeDiseaseSingle/' + patientId,body,httpOptions);
  }

deleteRelativeDiseaseSingle(id:number):Observable<BORelativeDisease>{
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BORelativeDisease>(this.myAppUrl + this.myApiUrl + 'deleteRelativeDiseaseSingle/' + id,null,httpOptions);
    }


//#endregion Single

}
